import { Container, Flex, Text } from '@chakra-ui/react';

/**
 * Footer component
 * @returns The Footer Component
 */
export default function Footer() {

	return (
		<Container maxWidth={"80%"} p={{ base: 5, md: 10 }}>
			<Flex
				alignItems="center"
				width={"100%"}
				justifyContent={"center"}
			>
				<Text
					fontFamily={"Source Code Pro Variable"}
					fontWeight={"600"}
					fontSize={"sm"}
					color={"white.300"}
					textAlign={"center"}
				>
					© 2026. Made with sticks, duct tape, and WD-40 by John Bajor. All rights reserved.
				</Text>
			</Flex>
		</Container>
	);
};
